import * as React from 'react';
import { EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../../types/requestForm';
import { createFields } from '../utils/createFields';
import { createValidation } from '../utils/createValidation';
import { SEND_FEEDBACK_BUTTON_TEXT } from '../../../../constants/requestForm/buttonText';
import { createField } from '../utils/createField';
import { ChangedPhoneMessageDescription } from '../../../../components/ChangedPhoneMessageDescription';
import { jsx as _jsx } from "react/jsx-runtime";
var FIELDS = [createField(EFormFieldsNames.Message, {
  label: 'Добавьте информацию об аккаунте - так вы подтвердите, что являетесь его владельцем',
  description: /*#__PURE__*/_jsx(ChangedPhoneMessageDescription, {})
}), EFormFieldsNames.Files, createField(EFormFieldsNames.Email, {
  description: 'Напишем, когда поменяем номер на актуальный'
}), EFormFieldsNames.Name, EFormFieldsNames.PrivacyPolicyAccepted];
export var CHANGED_PHONE_FINAL_STEP = {
  code: EStepCodes.ChangedPhoneFinal,
  question: {
    code: EQuestionCodes.ChangedPhoneFinal,
    title: 'Изменился номер телефона (шаг 2 из 2)',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: SEND_FEEDBACK_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [],
    nextStepCode: null
  }]
};